import { type JSX, memo } from "react";
import styled from "styled-components";
import CircularProgress from "../../shared/components/CircularProgrss";
import { useSelectedIds } from "../components/SelectedIds";
import LeaderboardInfo from "./LeaderboardInfo";
import LeaderboardTable from "./LeaderboardTable";
import type { IData } from "./query";
import ScoreboardInfo from "./ScoreboardInfo";
import { Box, Frame } from "./stylings";

interface IProps {
    data: IData;
}

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    h4 {
        margin: 0;
    }
`;

const ProgressContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

function CustomPerf({ data }: IProps): JSX.Element {
    const { pmId } = useSelectedIds();
    const leaderboards = data.pathMembership.learningPath.leaderboards;
    const scoreboards = data.pathMembership.learningPath.scoreboards;

    return (
        <Frame>
            {leaderboards.map((leaderboard) => (
                <Box key={leaderboard.id} $span={[12, 6, 4]}>
                    <Header>
                        <h4>{leaderboard.name}</h4>
                        <LeaderboardInfo leaderboard={leaderboard} />
                    </Header>
                    <LeaderboardTable leaderboard={leaderboard} currentPlayerMembershipId={pmId} />
                </Box>
            ))}
            {scoreboards.map((scoreboard) => (
                <Box key={scoreboard.id} $span={[12, 6, 4]}>
                    <Header>
                        <h4>{scoreboard.name}</h4>
                        <ScoreboardInfo scoreboard={scoreboard} />
                    </Header>
                    <ProgressContainer>
                        <CircularProgress proportion={scoreboard.score} label={scoreboard.name} />
                    </ProgressContainer>
                </Box>
            ))}
        </Frame>
    );
}

export default memo(CustomPerf);
